// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React, { FC } from 'react';

import {
  StyledHamburgerArea,
  StyledHamburgerButton,
  StyledHeader,
  StyledLogo,
  StyledTestEnvTag,
  StyledUsername
} from './Styled';
import appLogoImage from '../../../public/img-app-logo.png';
import { useMember } from '../../../providers/SessionProvider';
import Image from 'next/image';
import { useRouter } from 'next/router';

export interface HeaderProps {
  /** ログインしたかどうか */
  isLoggedIn?: boolean;
  /** 「へようこそ！」の文言を表示するかどうか */
  showGreeting?: boolean;
  /** 「会社名・スタッフ名」を非表示にするかどうか */
  hideUserName?: boolean;
  /** ロゴのリンクを無効化にするかどうか */
  disableMainLink?: boolean;
  /** サイドメニューがあるかどうか */
  hasSidePanelMenu?: boolean;
  /** ハンバーガーメニューが開いているかどうか */
  isHamburgerOpen?: boolean;
  /** ハンバーガーボタンのクリックイベント */
  onClickHamburger?: () => void;
}

export const Header: FC<HeaderProps> = (props) => {
  const { member } = useMember();
  const router = useRouter();
  return (
    <StyledHeader isLoggedIn={!props.hideUserName && props.isLoggedIn}>
      {props.hasSidePanelMenu && (
        <StyledHamburgerArea>
          <StyledHamburgerButton
            open={props.isHamburgerOpen}
            onClick={props.onClickHamburger}
          >
            <span className="bar" />
            <span className="bar" />
            <span className="bar" />
          </StyledHamburgerButton>
        </StyledHamburgerArea>
      )}
      <StyledLogo
        href={props.disableMainLink ? undefined : ''}
        onClick={(e) => {
          e.preventDefault();
          !props.disableMainLink && router.push('/dashboard');
        }}
      >
        <Image
          src={appLogoImage}
          alt="コネクト サービス"
          width={157}
          height={24}
        />
        {props.showGreeting && (
          <span className="logo-title pc-only">へようこそ！</span>
        )}
      </StyledLogo>
      {process.env.NEXT_PUBLIC_MODE !== 'production' && (
        <StyledTestEnvTag>検証環境</StyledTestEnvTag>
      )}
      {!props.hideUserName && props.isLoggedIn && (
        <>
          <StyledUsername>
            <span className="text">{member.companyName}</span>
            <span className="text">（スタッフ：{member.username}）</span>
          </StyledUsername>
        </>
      )}
    </StyledHeader>
  );
};

Header.displayName = 'Header';

export default Header;
